export const NumberFormattedCurrency = (num) => Intl.NumberFormat().format(num);
export const NumberFormatted = (num) => (num || num === 0 ? NumberFormattedCurrency(+num) : '');
